import { OnInit, Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { SecurityService } from 'app/shared/services/security.service';
import { AppConfig } from 'app/app.config';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { EmployeeService } from 'app/views/appviews/employee.service';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { Observable } from 'rxjs';
import { IDtoDemand } from 'app/shared/models/legal/demand/dto-demand.model';
import { DemandService } from 'app/views/appviews/demand.service';
@Component({
    selector: 'app-demand-process',
    styleUrls: ['demand.style.scss'],
    templateUrl: 'demand.template.html'
})
export class DemandComponent implements OnInit {
    /**Formularios */
    private showRoles: any;
    private employeeIniId: number;
    private profile: string;
    private employee: IDtoEmployee;
    private hasEmployee = false;
    private liquidationId: number;
    //private liquidation: IDtoLiquidation;
    private demand: IDtoDemand;
    private catalogLawyers: Observable<IDtoCatalog[]>;
    private catalogAuthorities: Observable<IDtoCatalog[]>;
    private catalogTypeConciliationMeetings: Observable<IDtoCatalog[]>;
    private catalogProceduralStages: IDtoCatalog[];
    @ViewChild('confirmSwal', { static: false }) private confirmSwal: SwalComponent;
    //steps
    isStepOneCompleted = false;
    isStepTwoCompleted = false;
    isStepThreeCompleted = false;
    isStepFourCompleted = false;
    isStepFiveCompleted = false;
    isStepSixCompleted = false;
    isStepSevenCompleted = false;

    isStepOneOneCompleted = false;
    isStepTwoTwoCompleted = false;
    isStepThreeThreeCompleted = false;
    isStepFourFourCompleted = false;

    private formDemandProcess: FormGroup;
    /**Inputs */
    //@Input() private demand: IDtoDemand;
    @Output() getDemand = new EventEmitter<IDtoDemand>();
    @Output() stageChanged = new EventEmitter<number>();
    step = 1;
    lockSaved: boolean;
    constructor(private spinner: NgxSpinnerService
        , private securityService: SecurityService
        , private configGeneral: AppConfig
        , private route: ActivatedRoute
        , private configurationService: ConfigurationService
        , private employeeService: EmployeeService
        , private identityService: IdentityService
        , private demandService: DemandService
        , private formBuilder: FormBuilder) {
            this.initializeFormDemandProcess();
        this.showRoles = this.securityService.getUserRolesStorage();
        if (this.showRoles !== '') {
            this.employeeIniId = this.showRoles.employeeId;
        }
    }
    ngOnInit(): void {
        this.demandService.currentStepChallenge$.subscribe((res) => {
            let diff = res - this.step;
            if (diff > 0) {
               this.lockSaved = true;
            } else {
                this.lockSaved = false;
            }
        });
        if (this.configurationService.isReady) {
            this.getCatalog();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.getCatalog();
            });
        }
        this.route.params.subscribe((params) => {
            if (params['liquidationId']) {
                setTimeout(() => {
                    //this.spinner.show();
                    if (this.configurationService.isReady) {
                        this.liquidationId = params['liquidationId'];
                        let employeeId = params['employeeId'];
                        let requisitionId = params['requisitionId'];
                        this.getEmployeeData(requisitionId);
                        this.getDemandByLiquidationId();
                    } else {
                        this.configurationService.settingsLoaded$.subscribe(x => {
                            this.liquidationId = params['liquidationId'];
                            let employeeId = params['employeeId'];
                            let requisitionId = params['requisitionId'];
                            this.getEmployeeData(requisitionId);
                        });
                    }
                }, 2);
            }
        });
    }
      // Método para manejar cambios en los pasos
    onChildDataSaved(event: {step: number, isCompleted: boolean, savedData?: any}) {
        switch(event.step) {
            case 2:
                this.isStepOneCompleted = event.isCompleted;
                // if(event.savedData) {
                //   this.demand.conciliatoryAppointmentBoard = event.savedData;
                // }
                break;
            case 3:
                this.isStepTwoCompleted = event.isCompleted;
                break;
            case 4:
                this.isStepThreeCompleted = event.isCompleted;
                break;
            case 5:
                this.isStepFourCompleted = event.isCompleted;
                break;
            case 6:
                this.isStepFiveCompleted = event.isCompleted;
                break;
            case 7:
                this.isStepSixCompleted = event.isCompleted;
                break;
            case 8:
                this.isStepSevenCompleted = event.isCompleted;
                break;
        }
      }
      onChildDataSaved2(event: {step: number, isCompleted: boolean, savedData?: any}) {
        switch(event.step) {
            case 1:
                this.isStepOneOneCompleted = event.isCompleted;
                break;
            case 2:
                this.isStepTwoTwoCompleted = event.isCompleted;
                break;
            case 3:
                this.isStepThreeThreeCompleted = event.isCompleted;
                break;
            case 8:
                this.isStepFourFourCompleted = event.isCompleted;
                break;
        }
      }
    private initializeFormDemandProcess() {
        this.formDemandProcess = this.formBuilder.group({
            lawyerId: [null, [Validators.required]],
            authorityId: [null, [Validators.required]],
            typeConciliationMeetingId: [null, [Validators.required]],
            proceduralStageId: [null, [Validators.required]]
        });
    }
    private getCatalog() {
        this.catalogLawyers = this.demandService.getCatalogLawyers();
        this.catalogAuthorities = this.demandService.getCatalogAuthorities();
        this.catalogTypeConciliationMeetings = this.demandService.getCatalogTypeConciliationMeetings();
    }
    private changeStage(dto: IDtoCatalog) {
        if (dto == undefined) {
            this.formDemandProcess.get('proceduralStageId').setValue(null);
            return;
        }
        this.demand.proceduralStageId = dto.id;
        this.getDemand.emit(this.demand)

        this.stageChanged.emit(this.demand.proceduralStageId);  // Emitir el ID o el DTO de la etapa
    }
    private changeAuthority(dto: IDtoCatalog) {
        //this.formDemandProcess.get('proceduralStageId').setValue(null);
        if (dto == undefined) {
            return;
        }
        this.demandService.getCatalogProceduralStages(dto.name).subscribe((x) => {
            this.catalogProceduralStages = x.filter(x => [1, 2].includes(x.id))
        });
        this.makeRequiredFields(dto.id);
    }
    private changeLawyer(dto: IDtoCatalog) {
        //this.formDemandProcess.get('proceduralStageId').setValue(null);
        if (dto == undefined) {
            return;
        }
        this.demand.lawyerId = dto.id;
    }
    private makeRequiredFields(value: number): void {
        if (value == 1) {
            this.formDemandProcess.get('typeConciliationMeetingId').setValidators([Validators.required]);
            this.formDemandProcess.get('proceduralStageId').setValidators([Validators.required]);
        } else {
            this.formDemandProcess.get('typeConciliationMeetingId').setValidators(null);
            this.formDemandProcess.get('proceduralStageId').setValidators(null);
        }
        this.formDemandProcess.get('typeConciliationMeetingId').updateValueAndValidity();
        this.formDemandProcess.get('proceduralStageId').updateValueAndValidity();
    }
    private submitForm(form: FormGroup) {
        if (form.valid) {
            const value = form.value;
            this.demand.lawyerId = value.lawyerId;
            this.demand.authorityId = value.authorityId;
            this.demand.typeConciliationMeetingId = value.typeConciliationMeetingId;
            this.demand.proceduralStageId = value.proceduralStageId;
            this.demand.liquidationId = this.liquidationId;
            this.demand.step = this.step; 
            if (this.demand.id > 0) {
                //this.updateDemand();
            } else {
                this.addDemand();
            }
        } else {
            this.configGeneral.newToast('Error', 'Llene todos los datos para poder continuar', 'error');
            this.configGeneral.touchedControls(form);
        }
    }
    private addDemand(): void {
        this.confirmSwal.title = 'Se guardarán los datos de la demanda. ¿Seguro que desea continuar?';
        this.confirmSwal.show().then((result) => {
            if (result.value) {
                this.spinner.show();
                this.demandService.addDemand(this.demand).subscribe(
                    (x) => {
                        if (x.isCorrect) {
                            this.configGeneral.newToast('Éxito', x.message, 'success');
                            this.demand = x.data as IDtoDemand
                            this.getDemand.emit(this.demand)
                            
                        } else {
                            this.configGeneral.newToast('Error', x.message, 'error');
                        }
                        this.spinner.hide();
                    },
                    (errMessage) => {
                        this.spinner.hide();
                        this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                    });
            }
        });

    }
    private patchValueGeneralData(): void {
        this.catalogAuthorities.subscribe(c => {
            let authority = c.filter(x => x.id == this.demand.authorityId)[0];
            this.changeAuthority(authority);
        });

        this.formDemandProcess.patchValue(this.demand);
        this.formDemandProcess.disable();
    }
    private getDemandByLiquidationId(): void {
        this.spinner.show()
        this.demandService.getDemandByliquidationId(this.liquidationId)
            .subscribe(
                (x) => {
                    if (x.data != null) {
                        this.demand = x.data as IDtoDemand;
                        this.demand.liquidationId = this.liquidationId;
                        if(this.demand.authorityId == 1) {
                            this.isStepOneCompleted = this.demand.conciliatoryAppointmentBoard != null;
                            this.isStepTwoCompleted = this.demand.receptionDemand != null;
                            this.isStepThreeCompleted = this.demand.answerDemand != null;
                            this.isStepFourCompleted = this.demand.offerAdmissionEvidence != null;
                            this.isStepFiveCompleted = this.demand.releaseEvidence != null;
                            this.isStepSixCompleted =  this.demand.allegation != null;
                            this.isStepSevenCompleted = this.demand.laudo != null;
                        } else {
                            this.isStepOneOneCompleted = this.demand.conciliatoryAppointmentCourt != null;
                            this.isStepTwoTwoCompleted = this.demand.preliminaryAudience != null;
                            this.isStepThreeThreeCompleted = this.demand.judgmentAudience != null;
                            this.isStepFourFourCompleted = this.demand.laudo != null;
                        }

                        this.patchValueGeneralData();
                    } else {
                        this.demand = {} as IDtoDemand;
                        this.demand.proceduralStageId = 1;
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private receiveDemand(dto: IDtoDemand) {
        this.demand = dto;
    }
    private getEmployeeData(requisitionId: number): void {
        this.spinner.show();
        this.employeeService.getEmployeeDataDismissalById(requisitionId).subscribe((res) => {
            this.employee = res;
            this.hasEmployee = true;
            this.spinner.hide();
        });
    }
    private addModuleLog(id: number, action: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Documents';
        dto.module = 'Liquidation';
        dto.action = action;
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
}
